import React from "react"
import Typed from "typed.js"
import ScrollableAnchor from "react-scrollable-anchor"
// nodejs library that concatenates classes
import classNames from "classnames"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// core components
import Header from "../../components/Header/Header.jsx"
import Footer from "../../components/Footer/Footer.jsx"
import GridContainer from "../../components/Grid/GridContainer.jsx"
import GridItem from "../../components/Grid/GridItem.jsx"
import Button from "../../components/CustomButtons/Button.jsx"
import HeaderLinks from "../../components/Header/HeaderLinks.jsx"
import Parallax from "../../components/Parallax/Parallax.jsx"

import landingPageStyle from "../../assets/jss/material-kit-react/views/landingPage.jsx"
// Sections for this page
import ProductSection from "./Sections/FeaturesSection.jsx"
import ContactFormSection from "./Sections/ContactFormSection.jsx"
import logo from "../../assets/img/mibLogoCorrect.svg"
import ProductImagesSection from "./Sections/ProductImagesSection"
import PricingSection from "./Sections/PricingSection"
import FooterSecond from "../../components/Footer/FooterSecond"
import MarketingSection from "./Sections/MarketingSection"

// @material-ui/icons

const dashboardRoutes = []

class LandingPage extends React.Component {
    componentDidMount() {
        // eslint-disable-next-line
        const typed = new Typed(".typed-text", {
            strings: [
                "restaurant.",
                "pizzeria.",
                "sushi restaurant.",
                "cafe.",
                "taqueria.",
                "izakaya.",
                "burger joint.",
                "thai restaurant.",
            ],
            typeSpeed: 80,
            backSpeed: 30,
            loop: true,
            loopCount: Infinity,
        })
    }

    render() {
        const { classes, ...rest } = this.props
        return (
            <div>
                <ScrollableAnchor id="home">
                    <div>
                        <Header
                            color="transparent"
                            routes={dashboardRoutes}
                            brand={<img style={{ width: "8rem", height: "3.5rem" }} src={logo} alt="" />}
                            fixed
                            rightLinks={<HeaderLinks />}
                            changeColorOnScroll={{
                                height: 200,
                                color: "white",
                            }}
                            {...rest}
                        />
                        <Parallax filter image={require("../../assets/img/thai_food.jpg")}>
                            <div className={classes.container}>
                                <GridContainer
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        "@media (minWidth: 1200px)": {
                                            marginRight: "-50px",
                                            marginLeft: "-50px",
                                        },
                                    }}>
                                    <GridItem xs={10} sm={10} lg={7} style={{ textAlign: "center" }}>
                                        <h1
                                            className={classes.title}
                                            style={{ fontFamily: "Open Sans", marginBottom: 0, fontWeight: "500" }}>
                                            <span>Leap forward.</span>
                                        </h1>
                                    </GridItem>
                                    <GridItem xs={10} sm={10} lg={7} style={{ textAlign: "center" }}>
                                        <h1
                                            className={classes.title}
                                            style={{
                                                fontFamily: "Open Sans",
                                                marginTop: "2rem",
                                                fontWeight: 300,
                                                fontSize: "2.5rem",
                                            }}>
                                            Online ordering for your{" "}
                                            <span style={{ color: "#FFC915" }} className="typed-text" />
                                        </h1>
                                        <h4 style={{ fontWeight: "400" }}>
                                            Your brand. Your customers. Your online ordering platform.
                                        </h4>
                                        <br />
                                        <Button
                                            className={classes.tryNowButton}
                                            color="primary"
                                            size="sm"
                                            href="#contact"
                                            rel="noopener noreferrer">
                                            Try Now
                                        </Button>
                                    </GridItem>
                                </GridContainer>
                            </div>
                        </Parallax>
                        <div className={classNames(classes.main, classes.mainRaised)}>
                            <div className={classes.container}>
                                <ProductSection id="about" />
                                <ProductImagesSection />
                                <PricingSection />
                                {/* <PricingInfoSection /> */}
                                {/* <TeamSection id="team"/> */}
                                <MarketingSection />
                                <ContactFormSection />
                            </div>
                        </div>
                        <Footer />
                        <FooterSecond />
                    </div>
                </ScrollableAnchor>
            </div>
        )
    }
}

export default withStyles(landingPageStyle)(LandingPage)



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx